import { render } from "./DriverGates.vue?vue&type=template&id=66dd07e4"
import script from "./DriverGates.vue?vue&type=script&lang=js"
export * from "./DriverGates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__